<script lang="ts">
	import PageGrid from '../components/pageGrid.svelte';
	import Carousel from '$lib/carousel.svelte';
	import ReviewCard from '../parts/reviews/reviewCard.svelte';
	import Image from '../components/image.svelte';
	import type { SbImage } from '../types';
	import ArrowLeft from '$lib/icons/arrowLeft.svelte';
	import ArrowRight from '$lib/icons/arrowRight.svelte';
	import type { EmblaCarouselType } from 'embla-carousel';
	import { browser } from '$app/environment';
	import { checkVisibility } from '$lib/actions/checkVisibility';
	import type { Review } from '$lib/types/yotpo';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			title: string;
			subline_image: SbImage;
		}>['content'];
	}

	let { content }: Props = $props();

	let reviews = $state<Array<Review>>([]);

	async function fetchReviews() {
		if (!browser) return [];

		const res = await fetch('/api/yotpo/reviews?perPage=20');
		const response = await res.json();

		reviews = response.reviews;
	}

	let embla = $state<EmblaCarouselType>();
	let active = $state(0);

	function next() {
		if (embla) {
			embla.scrollNext();
		}
	}

	function previous() {
		if (embla) {
			embla.scrollPrev();
		}
	}
</script>

<div
	use:editable={content}
	class="w-screen overflow-hidden text-brown-2"
	use:checkVisibility={{ threshold: 0 }}
	onvisible={({ detail }) => {
		if (!detail || reviews.length > 0) return;

		fetchReviews();
	}}
>
	<PageGrid class="text-brown-2">
		<section class="col-span-full">
			<div class="flex justify-between">
				<h1 class="text-[32px]/[110%] font-semibold">{content.title}</h1>

				<div class="flex gap-x-4">
					<button class:opacity-25={active === 0} onclick={previous}
						><ArrowLeft class="h-6 w-6" /></button
					>
					<button class:opacity-25={active >= reviews.length - 1} onclick={next}
						><ArrowRight class="h-6 w-6" /></button
					>
				</div>
			</div>
			<Image class="mt-0.5 h-7 lg:mt-2.5 lg:h-[35px]" src={content.subline_image.filename} />
			<Carousel
				bind:embla
				bind:currentIndex={active}
				overflow
				containerClass="mt-4 lg:mt-7"
				class="flex gap-x-8"
			>
				{#each reviews as review}
					<div class="flex-none basis-[80%] lg:basis-[24%]">
						<ReviewCard {review} />
					</div>
				{/each}
			</Carousel>
		</section>
	</PageGrid>
</div>
